import React, { useState, useEffect, useCallback } from 'react';
import {
  CardBody,
  Row,
  Col,
  Card,
  Container,
  CardHeader,
  Modal,
  ModalFooter,
  ModalHeader,
  ModalBody,
  Label,
  Input,
  Button,
} from 'reactstrap';
import DataTable from 'react-data-table-component';
import BreadCrumb from '../../Components/Common/BreadCrumb';
import DeleteModal from '../../Components/Common/DeleteModal';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';
import { api } from '../../config';
import { getAuthToken } from '../../auth/tokenvalidation';

const IndexClauseList = () => {
  const token = getAuthToken();

  const [data, setData] = useState({ items: [] });
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);
  const [invoice, setInvoice] = useState(null);
  const [modal, setModal] = useState(false);
  const [errors, setErrors] = useState({});
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(15);
  const [modalIndexClause, setModalIndexClause] = useState(false);
  const [indexPriceFormData, setIndexClauseFormData] = useState({
    clauseTitle: null,
    ordreNumber: null,
    isShow: null,
    id: null,
  });

  const [filterText, setFilterText] = useState('');
  const [filteredData, setFilteredData] = useState([]);

  const handleDeleteModal = id => {
    const selectedRow = data.items.find(item => item.id === id);
    setInvoice(selectedRow);
    setDeleteModal(true);
  };

  const handleDeleteInvoice = async () => {
    if (invoice) {
      try {
        const response = await fetch(
          `${api.API_URL}/clause-detail/${invoice.id}`,
          {
            method: 'DELETE',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(
            errorData.message || `HTTP error! status: ${response.status}`
          );
        }

        toast.success('Clause Detail berhasil dihapus!', { autoClose: 3000 });
        setDeleteModal(false);
        setInvoice(null);
        fetchData(currentPage, rowsPerPage, token);
      } catch (err) {
        toast.error(`Gagal menghapus clause detail: ${err.message}`, {
          autoClose: 3000,
        });
      }
    }
  };

  const deleteMultiple = () => {
    // Implement multiple delete functionality
    // This would typically involve deleting selected items
    // For now, just close the modal
    setDeleteModalMulti(false);
  };

  const toggleIndexClauseClause = () => {
    setModal(!modal);
  };

  const columns = [
    {
      name: (
        <span className='form-label  text-uppercase fw-semibold fs-13'>
          Title{' '}
        </span>
      ),
      selector: row => row.clauseTitle,
      sortable: true,
      width: '70%',
      wrap: true,

      cell: row => {
        return (
          <>
            <h6 className={'mb-0'}>{row.clauseTitle}</h6>
          </>
        );
      },
    },

    {
      name: (
        <span className='form-label  text-uppercase fw-semibold fs-13'>
          Order No{' '}
        </span>
      ),
      selector: row => row.ordreNumber,
      sortable: true,
      width: '10%',
      wrap: true,
      center: true,
      cell: row => {
        return (
          <>
            <h6 className={'mb-0'}>{row.ordreNumber}</h6>
          </>
        );
      },
    },

    {
      name: (
        <span className='form-label  text-uppercase fw-semibold fs-13'>
          Active{' '}
        </span>
      ),
      selector: row => row.isShow,
      sortable: true,
      width: '10%',
      wrap: true,
      center: true,
      cell: row => {
        return (
          <>
            <i
              className={
                row.isShow
                  ? 'ri-checkbox-circle-line text-success fs-4'
                  : 'ri-close-circle-line text-danger fs-4'
              }
            />
          </>
        );
      },
    },

    {
      name: (
        <span className='form-label  text-uppercase fw-semibold fs-13'>
          Action
        </span>
      ),
      width: '10%',
      sortable: false,
      className: 'text-end',
      center: true,
      cell: row => (
        <div className='d-flex gap-1 justify-content-end'>
          <button
            className='btn btn-soft-info btn-sm btn-icon'
            onClick={() => handleUpdateModal(row.id)}
          >
            <i className='ri-pencil-fill align-bottom'></i>
          </button>
          <button
            className='btn btn-soft-danger btn-sm btn-icon'
            onClick={() => handleDeleteModal(row.id)}
          >
            <i className='ri-delete-bin-6-line align-bottom'></i>
          </button>
        </div>
      ),
    },
  ];

  document.title = 'Data Clause Detail';

  const handleChange = e => {
    const { name, value } = e.target;
    setIndexClauseFormData({ ...indexPriceFormData, [name]: value });
  };

  useEffect(() => {
    fetchData(currentPage, rowsPerPage, token);
  }, [currentPage, rowsPerPage, token]);

  // Filter data based on search text
  useEffect(() => {
    if (filterText) {
      const filtered = data.items.filter(
        item =>
          item.clauseTitle?.toLowerCase().includes(filterText.toLowerCase()) ||
          item.ordreNumber?.toLowerCase().includes(filterText.toLowerCase())
      );
      setFilteredData(filtered);
    } else {
      setFilteredData(data.items);
    }
  }, [data.items, filterText]);

  const handleFilterChange = e => {
    setFilterText(e.target.value);
  };

  const clearFilter = () => {
    setFilterText('');
  };

  const fetchData = async (currentPage, rowsPerPage, token) => {
    fetch(
      `${api.API_URL}/clause-detail?PageNumber=${currentPage}&PageSize=${rowsPerPage}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        credentials: 'same-origin',
      }
    )
      .then(data => data.json())
      .then(
        result => {
          setData({
            items: result.data.items || [],
          });
          setTotalRows(result.data.totalItems || 0);
        },
        _error => {
          // Handle error appropriately
        }
      )
      .catch(_error => {
        // Handle error silently or show appropriate message
      });
  };

  const handlePageChange = useCallback(page => {
    setCurrentPage(page);
  }, []);

  const handlePerRowsChange = useCallback(newPerPage => {
    setRowsPerPage(newPerPage);
    setCurrentPage(1);
  }, []);

  const handleNewModal = () => {
    setIndexClauseFormData({
      clauseTitle: null,
      ordreNumber: null,
      isShow: null,
      id: null,
    });
    indexPriceClause();
  };

  const handleUpdateModal = (mid = null) => {
    fetchIndexClauseDetail(mid);
    indexPriceClause();
  };

  const indexPriceClause = () => {
    setModalIndexClause(!modalIndexClause);
  };

  const selectedFieldsIndexClause = {
    clauseTitle: indexPriceFormData.clauseTitle,
    ordreNumber: indexPriceFormData.ordreNumber,
    isShow: indexPriceFormData.isShow,
  };

  const handleAddDataIndexClause = async () => {
    try {
      await axios.post(
        `${api.API_URL}/clause-detail`,
        selectedFieldsIndexClause,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      );
      toast.success(`Clause Detail Has been Added`);
    } catch (error) {
      toast.error(`Failed to save data: ${error.message}`);
    } finally {
      fetchData(currentPage, rowsPerPage, token);
    }
  };

  const fetchIndexClauseDetail = async mid => {
    try {
      const response = await axios.get(`${api.API_URL}/clause-detail/${mid}`, {
        withXSRFToken: true,
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: `application/json`,
        },
      });
      const data = response;
      setIndexClauseFormData({
        clauseTitle: data.clauseTitle || null,
        ordreNumber: data.ordreNumber || null,
        isShow: data.isShow ?? null,
        id: data.id || null,
      });
    } catch (error) {
      // Handle error silently or show appropriate message
    }
  };

  const handleUpdDataIndexClause = async mid => {
    try {
      await axios.put(
        `${api.API_URL}/clause-detail/${mid}`,
        selectedFieldsIndexClause,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      );
      toast.success(`Data Has been Updated`);
    } catch (error) {
      toast.error(`Failed to save data: ${error.message}`);
    } finally {
      fetchData(currentPage, rowsPerPage, token);
    }
  };

  return (
    <React.Fragment>
      <div className='page-content'>
        <DeleteModal
          show={deleteModal}
          onDeleteClick={() => handleDeleteInvoice()}
          onCloseClick={() => setDeleteModal(false)}
        />
        <DeleteModal
          show={deleteModalMulti}
          onDeleteClick={() => {
            deleteMultiple();
            setDeleteModalMulti(false);
          }}
          onCloseClick={() => setDeleteModalMulti(false)}
        />
        <Container fluid>
          <BreadCrumb title='View Data' pageTitle='Clause Detail' />

          <Row>
            <Col lg={12}>
              <Card id='ClauseDetailList'>
                <CardHeader className='border-0'>
                  <div className='d-flex align-items-center'>
                    <h5 className='card-title mb-0 flex-grow-1'>
                      Data Clause Detail
                    </h5>
                    <div className='flex-shrink-0'>
                      <div className='d-flex gap-2 flex-wrap'>
                        <button
                          type='button'
                          className='btn btn-primary btn-label right ms-auto nexttab btn-sm'
                          onClick={() => handleNewModal()}
                        >
                          <i className='ri-play-list-add-line label-icon align-middle fs-16 ms-2'></i>{' '}
                          <span className='d-none d-sm-inline'>
                            Create New Clause Detail
                          </span>
                          <span className='d-sm-none'>New</span>
                        </button>
                      </div>
                    </div>
                  </div>

                  {/* Filter Section */}
                  <div className='d-flex justify-content-between align-items-center mt-3'>
                    <div className='d-flex align-items-center gap-2'>
                      <Input
                        type='text'
                        placeholder='Search clause details...'
                        value={filterText}
                        onChange={handleFilterChange}
                        style={{ width: '300px' }}
                        className='form-control-sm'
                      />
                      {filterText && (
                        <Button
                          color='secondary'
                          size='sm'
                          onClick={clearFilter}
                          outline
                        >
                          <i className='ri-close-line'></i> Clear
                        </Button>
                      )}
                    </div>
                  </div>
                </CardHeader>

                <CardBody className='pt-0'>
                  <div
                    className='table-responsive'
                    style={{
                      minHeight: 'auto',
                      display: 'flex',
                      flexDirection: 'column',
                    }}
                  >
                    <DataTable
                      columns={columns}
                      highlightOnHover
                      data={filteredData}
                      pagination
                      paginationServer={!filterText}
                      paginationTotalRows={
                        filterText ? filteredData.length : totalRows
                      }
                      onChangePage={handlePageChange}
                      onChangeRowsPerPage={handlePerRowsChange}
                      showPaginationBottom={true}
                      wrap
                      dense
                      striped
                      fixedHeader={false}
                      fixedHeaderScrollHeight={undefined}
                      noDataComponent={
                        <div
                          style={{
                            padding: '20px',
                            textAlign: 'center',
                            color: '#6c757d',
                          }}
                        >
                          <i
                            className='ri-database-2-line'
                            style={{
                              fontSize: '32px',
                              marginBottom: '8px',
                              display: 'block',
                            }}
                          ></i>
                          No clause details found
                        </div>
                      }
                      defaultSortFieldId={1}
                      defaultSortAsc={true}
                      customStyles={{
                        header: {
                          style: {
                            backgroundColor: '#f0f0f0',
                            color: '#333',
                            fontWeight: 'bold',
                          },
                        },
                        headCells: {
                          style: {
                            backgroundColor: '#f0f0f0',
                            fontWeight: 'bold',
                            fontSize: '14px',
                            paddingLeft: '12px',
                            paddingRight: '12px',
                            borderRight: '1px solid #dee2e6',
                          },
                        },
                        cells: {
                          style: {
                            paddingLeft: '12px',
                            paddingRight: '12px',
                            wordBreak: 'break-word',
                            borderRight: '1px solid #dee2e6',
                          },
                        },
                        rows: {
                          style: {
                            minHeight: '50px',
                            '&:hover': {
                              backgroundColor: '#f8f9fa',
                            },
                          },
                        },
                        table: {
                          style: {
                            width: '100%',
                            minWidth: '100%',
                            tableLayout: 'fixed',
                          },
                        },
                        responsiveWrapper: {
                          style: {
                            overflowX: 'hidden',
                            display: 'flex',
                            flexDirection: 'column',
                          },
                        },
                        pagination: {
                          style: {
                            borderTop: '1px solid #dee2e6',
                            backgroundColor: '#f8f9fa',
                            margin: 0,
                            padding: '8px 0',
                          },
                        },
                      }}
                    />

                    <ToastContainer closeButton={false} limit={1} />
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Modal
            isOpen={modalIndexClause}
            role='dialog'
            autoFocus={true}
            centered
            id='addIndexClauseClause'
            toggle={toggleIndexClauseClause}
            data-bs-backdrop='static'
            size='sm'
          >
            <ModalHeader
              className='bg-soft-info'
              toggle={() => {
                setModalIndexClause(!modalIndexClause);
              }}
            >
              <span className='modal-title text-info fw-bold'>
                {indexPriceFormData.id !== null
                  ? 'Edit Clause Detail'
                  : 'Add Clause Detail'}
              </span>
            </ModalHeader>

            <ModalBody>
              <div className='d-flex mt-2'>
                <Col sm={12}>
                  <Row>
                    <Col sm={12}>
                      <div className='mb-1'>
                        <Label for='clauseTitle' className='form-label '>
                          Title :
                        </Label>
                        <div className='input-group'>
                          <Input
                            type='text'
                            id='clauseTitle'
                            name='clauseTitle'
                            className='form-control'
                            value={indexPriceFormData.clauseTitle || ''}
                            onChange={e => {
                              handleChange(e);
                              setErrors({
                                ...errors,
                                clauseTitle: '',
                              });
                            }}
                          />
                        </div>
                      </div>
                    </Col>
                    <Col sm={12}>
                      <div className='mb-1'>
                        <Label htmlFor='ordreNumber' className='form-label'>
                          Order No{' '}
                        </Label>
                        <div className='input-group'>
                          <Input
                            type='text'
                            id='ordreNumber'
                            name='ordreNumber'
                            className='form-control'
                            value={indexPriceFormData.ordreNumber || ''}
                            onChange={e => {
                              handleChange(e);
                              setErrors({
                                ...errors,
                                ordreNumber: '',
                              });
                            }}
                          />
                        </div>
                      </div>
                    </Col>
                    <Col sm={12}>
                      <div className='form-check form-switch form-switch-lg mt-3'>
                        <Input
                          type='switch'
                          id='isShow'
                          name='isShow'
                          className='form-check-input'
                          checked={indexPriceFormData.isShow ?? false}
                          onChange={e => {
                            setIndexClauseFormData(prev => ({
                              ...prev,
                              isShow: e.target.checked,
                            }));
                            setErrors({
                              ...errors,
                              isShow: '',
                            });
                          }}
                        />
                        <Label className='form-check-label ms-2' for='isShow'>
                          Active
                        </Label>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </div>
            </ModalBody>

            <ModalFooter>
              <Button
                color='danger'
                className='btn-label btn-sm right'
                onClick={() => {
                  setModalIndexClause(!modalIndexClause);
                }}
              >
                {' '}
                <i className=' ri-close-circle-line label-icon align-middle fs-16 ms-2'></i>{' '}
                Close
              </Button>
              <Button
                color='primary'
                className='btn-label btn-sm right'
                onClick={() => {
                  setModalIndexClause(!modalIndexClause);
                  indexPriceFormData.id !== null
                    ? handleUpdDataIndexClause(indexPriceFormData.id)
                    : handleAddDataIndexClause();
                }}
              >
                {' '}
                <i className='ri-database-2-line label-icon align-middle fs-16 ms-2'></i>{' '}
                {indexPriceFormData.id !== null ? 'Update' : 'Save'}
              </Button>
            </ModalFooter>
          </Modal>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default IndexClauseList;
